export default __webpack_public_path__ + "static/media/close-preview-icon.40e69904.svg";